import { Component, OnInit } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AuditService } from '../../services/audit.service';
import { takeUntil } from 'rxjs/operators';
import { AuditCardAcceptorConfigViewModel } from '../../models/audit-trail-card-acceptor-config-view-model';
import { LoggedInUser } from '../../models/user';
import { ParticipantViewModel } from '../../models/participant-view-model';
import { UserDataStoreService } from '../../services/user-data-store.service';
import { ConfirmationDialogComponent } from '../../partials/confirmation-dialog/confirmation-dialog.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PermissionEnum } from '../../services/guards/permissions';
import { ToastrService } from 'ngx-toastr';
import { CardAcceptorConfigService } from '../../services/card-acceptor-config.service';
import { LanguagesViewModel } from 'src/app/models/languages-view-model';
import { Select2OptionData } from 'ng-select2';
import * as moment from 'moment';

@Component({
  selector: 'app-merchant-config-audit',
  templateUrl: './merchant-config-audit.component.html',
  styleUrls: ['./merchant-config-audit.component.scss']
})
export class MerchantConfigAuditComponent implements OnInit {

  public dtTrigger: Subject<boolean> = new Subject();
  private _destroyed$ = new Subject<any>();
  public AuditCardAcceptorConfig: AuditCardAcceptorConfigViewModel[] = [];
  public currentUser: Observable<LoggedInUser>;
  public participants: ParticipantViewModel[];
  public selectedParticipant: number;
  public selectedParticipantName: string;

  public dtOptions: DataTables.Settings = {};
  public id: string;
  public currentDate: string;
  public canView: boolean;
  public languages: Select2OptionData[]; //Added by Lebohang 10 Feb 2021
  public selectedLanguage: string; //Added by Lebohang 10 Feb 2021

  constructor(private _route: ActivatedRoute,
    private _ngxUiLoaderService: NgxUiLoaderService,
    private _auditService: AuditService,
    private _userDataStore: UserDataStoreService,
    private _modalService: NgbModal,
    private _toastService: ToastrService,
    private _cardAcceptorConfigService: CardAcceptorConfigService,
    private _router: Router) {

    this.currentUser = _userDataStore.currentUser
    this.participants = this._userDataStore.userParticipants;
    this.selectedParticipant = this._userDataStore.selectedParticipant.id;

    _route.params.pipe(takeUntil(this._destroyed$)).subscribe(async params => {
      this.id = params.id;
    });

    var today = new Date();
    // var yyyy = today.getFullYear();
    // var mm = today.getMonth();
    // var day = today.getDay();
    this.currentDate = moment(today).format('lll'); //'' + yyyy + '-' + mm + '-' + day;

    this.canView = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewMerchantAudit], []);
    if (!this.canView) {
      this._toastService.warning("You do not have the required permissions to view this page, Please contact your system administrator", "Warning");
      this._router.navigate(['/']);
    }
  }

  ngOnInit() {
    this.init();
    this.getDefaults();
  }

  public async getDefaults(): Promise<void> {

    this.languages = (await this._cardAcceptorConfigService.GetLanguages()).map((x) => {
      return { id: x.language.toString(), text: x.description }
    });
  }

  public async initTable(selectedIndex: number): Promise<void> {

    if (selectedIndex == 2) {
      this.dtTrigger = new Subject();
      this.dtTrigger.next();
    }
  }

  private async init(): Promise<void> {

    this._ngxUiLoaderService.start();

    this.AuditCardAcceptorConfig = await this._auditService.GetCardAcceptorConfigsByIdentifier("" + this.id);
    this.dtTrigger.next();

    this._ngxUiLoaderService.stop();
  }

  public async openReadMoreDialog(audit: AuditCardAcceptorConfigViewModel): Promise<void> {

    for (let x = 0; x < this.languages.length; x++) {
        if (audit.defaultLang == x) {
        this.selectedLanguage = this.languages[x].text
      }
    }
    const dialogRef = this._modalService.open(ConfirmationDialogComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    dialogRef.componentInstance.showCancel = false;
    dialogRef.componentInstance.acceptButtonText = "Close";
    dialogRef.componentInstance.title = "Merchant Config audit trail";

    var str = [];
    // str.push("Id: " + audit.id);
    //str.push("Changed By: " + audit.changedBy);
    //str.push("changed On: " + audit.changedOn);
    //str.push("source: " + audit.source);
    str.push("User Id: " + audit.userId);
    //str.push("name: " + audit.name);
    str.push("Participant Id: " + audit.participantId);
    //str.push("Config type: " + (audit.configType == 1 ? "TermApp" : "PostTerm"));
    //str.push("country: " + audit.country);
    //str.push("currencyCode: " + audit.currencyCode);
    str.push("CVS RetailerId: " + audit.cvsRetailerId);
    str.push("Default Lang: " + this.selectedLanguage);
    //str.push("limitsClass: " + audit.limitsClass);
    //str.push("merchantActive: " + audit.merchantActive);
    str.push("Merchant status: " + audit.merchantStatus);
    str.push("NUI: " + audit.nui);
    str.push("Receipt group Id: " + audit.receiptGroupId);
    str.push("Region: " + audit.region);
    //str.push("routingGroup: " + audit.routingGroup);
    str.push("Status: " + audit.status);
    str.push("Support Team: " + audit.supportTeam);
    str.push("Transaction Threshold: " + audit.transactionThreshold);
    str.push("Velocity Period: " + audit.velocityPeriod);
    str.push("Velocity Threshold: " + audit.velocityThreshold);
    str.push("Worst Event Severity: " + audit.worstEventSeverity);
    dialogRef.componentInstance.listMessage = str;

  }

  public print(): void {
    let printContents, popupWin;
    printContents = document.getElementById('content').innerHTML;
    popupWin = window.open('', '_blank', 'top=50,left=1,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>
           <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css">
        </head>
        <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }

  public DownloadCardAcceptorAuditDetailsCsv(): void {
    const data = this.AuditCardAcceptorConfig;
    const replacer = (key, value) => (value === null ? '' : value); // specify how you want to handle null values here
    const header = Object.keys(data[0]);
    const csv = data.map((row) =>
      header
        .map((fieldName) => JSON.stringify(row[fieldName], replacer))
        .join(',')
    );
    csv.unshift(header.join(','));
    const csvArray = csv.join('\r\n');

    const a = document.createElement('a');
    const blob = new Blob([csvArray], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    a.href = url;
    a.download = ('MerchantConfigAuditTrail_' + this.currentDate + ".csv");
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }


  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
    //this.subscription.unsubscribe();
  }
}
